import { getSchema } from '../schema/getSchema';
const storageSymbol = Symbol.for('DebugPanelStorage');
export function makePersistent(obj, storage, { keys, } = {}) {
    if (!keys) {
        const schema = getSchema(obj);
        if (schema) {
            keys = Object.entries(schema)
                .filter(([key, info]) => info.persistent)
                .map(([key]) => key);
        }
        else {
            keys = Object.keys(obj);
        }
    }
    obj[storageSymbol] = storage;
    keys.forEach((key) => {
        const defaultValue = obj[key];
        Object.defineProperty(obj, key, {
            set(value) {
                storage.setItem(key, value);
            },
            get() {
                return storage.getItem(key, defaultValue);
            },
        });
    });
    return obj;
}
export function getStorage(obj) {
    if (!obj) {
        return;
    }
    return obj[storageSymbol];
}
//# sourceMappingURL=makePersistent.js.map